
/* NgRx */
import { createAction, props } from '@ngrx/store';

export const loadMaterias = createAction(
  '[FiltroBuscar Page] Load Materias',
);

export const loadMateriasMcp = createAction(
  '[FiltroBuscar Page] Load Materias MCP',
);

export const selectedMaterias = createAction(
  '[FiltroBuscar Page] Materias Selected',
  props<{ selectedMaterias: number[] }>()
);

export const selectedMateria = createAction(
  '[FiltroBuscar Page] Materia Selected',
  props<{ selectedMateria: number }>()
);

export const cleanSelectedMaterias = createAction(
  '[FiltroBuscar Page] Clear Materias Selected',
);

export const loadCursos = createAction(
  '[FiltroBuscar Page] Load Cursos',
  props<{ soloActivos: boolean }>()
);

export const selectedCursos = createAction(
  '[FiltroBuscar Page] Cursos Selected',
  props<{ selectedCursos: number[] }>()
);

export const selectedCurso = createAction(
  '[FiltroBuscar Page] Curso Selected',
  props<{ selectedCurso: number }>()
);

export const cleanSelectedCursos = createAction(
  '[FiltroBuscar Page] Clear Cursos Selected',
);

export const loadPeriodos = createAction(
  '[FiltroBuscar Page] Load Periodos',
  props<{ includeNonActive: boolean }>()
);

export const selectedPeriodos = createAction(
  '[FiltroBuscar Page] Periodos Selected',
  props<{ selectedPeriodos: number[] }>()
);

export const selectedPeriodo = createAction(
  '[FiltroBuscar Page] Periodo Selected',
  props<{ selectedPeriodo: number }>()
);

export const cleanSelectedPeriodos = createAction(
  '[FiltroBuscar Page] Clear Periodos Selected',
);

export const selectedNombre = createAction(
  '[FiltroBuscar Page] Nombre Selected',
  props<{ selectedNombre: string }>()
);

export const selectedEstado = createAction(
  '[FiltroBuscar Page] Estado Permiso Selected',
  props<{ selectedEstado: number }>()
);

export const loadSesiones = createAction(
  '[FiltroBuscar Page] Load Sesiones',
);

export const selectedSesiones = createAction(
  '[FiltroBuscar Page] Sesiones Selected',
  props<{ selectedSesiones: number[] }>()
);

export const cleanSelectedSesiones = createAction(
  '[FiltroBuscar Page] Clear Sesiones Selected',
);

export const selectedIsNuevo = createAction(
  '[FiltroBuscar Page] Is Nuevo Selected',
  props<{ selectedIsNuevo: boolean }>()
);
